module.exports = __webpack_public_path__ + "static/doctor-02-38f05b645ff42a2f0582fd89f3dac060.png";